import React from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash.debounce';

class Search extends React.Component {
  constructor () {
    super();

    this.state = {
      searchValue: ''
    };

    this.onChangeDebounced = debounce(this.onChangeDebounced, 3000);
  }

  handleSearch = (event) => {
    this.setState({ searchValue: event.target.value });
    this.onChangeDebounced(event.target.value);
  }

  onChangeDebounced = (value) => {
    this.props.handleSearchValueChange(value);
  }

  clearSearch = () => {
    this.setState({ searchValue: '' });
    this.props.clearSearchValue();
  }

  render () {
    return (
      <div className='search-box'>
        <div className='input-wrapper'>
          <i className='icon-search' />
          <input type='text' className='form-control' placeholder='Search' value={this.state.searchValue}
            onChange={this.handleSearch} />
          {this.state.searchValue
            ? <a
              className='clear-search'
              href='javascript:;' onClick={this.clearSearch}
            >
              <i className='icon-close' />
            </a>
            : null}
        </div>
      </div>
    );
  }
}

Search.propTypes = {
  handleSearchValueChange: PropTypes.func.isRequired,
  clearSearchValue: PropTypes.func.isRequired
};

export default Search;
